import React from "react";
import { Table, Input } from "semantic-ui-react";
const SearchTextBoxNew = (props) => {
  const { onSearchButtonClick, type } = props;
  const id = "keyword" + type;
  const btn = "searcBtn" + type;
  return (
    <React.Fragment>
      <input id={id} className="input" placeholder="Search by keyword" />
      <div></div>
      <button
        onClick={() =>
          onSearchButtonClick(document.getElementById(id).value, type)
        }
        id={btn}
        className="btn btn--primary"
        type="button"
      >
        Search
      </button>
      <div></div>
      <button
        onClick={function () {
          document.getElementById(id).value = "";
          document.getElementById(btn).click();
        }}
        className="btn btn--secondary"
        type="button"
      >
        Reset
      </button>
    </React.Fragment>
  );
};

export default SearchTextBoxNew;
